module.exports = __webpack_public_path__ + "img/webeditor-6.74b058b5.gif";